<template>
  <div>
    <!-- <top></top> -->
    <!-- start -->
    <div class="topContent">
      <div class="content bgImgCss">
        <img :src="bgImg" alt class="imgSrcCss">
        <div class="contentPosition">
          <div class="contentTop">海底捞</div>
          <div class="contentBottom">
            <div>老牌网红餐厅的1到2智慧升级</div>
          </div>
        </div>
      </div>
    </div>
    <!-- end -->
    <!-- 面包屑 start -->
    <!-- <Bread :breadChild="toBreadChild"></Bread> -->
    <!-- 面包屑 end -->
    <div class="titleBox">
      <div class="anliTitle" style="margin-top:118px">项目背景</div>
      <div class="lineCss"></div>
    </div>
    <!-- start -->
    <!-- start -->
    
      <div class="productParent marginTop109">
        <div class="productLeft">
          <img :src="productLeft1Top">
        </div>
        <div class="productRight">
          <div class="productRightTitle">
            作为餐饮行业标杆，海底捞对服务质量力求做到顶级。
            在智能技术蓬勃发展的当下，海底捞认为原有数字化系统已不满足需求，
            痛点如下：
          </div>
          <div class="productRightText">
            1.门店内显示设备多样，PAD，大屏，广告机，系统不统一，无法实现统一化管理；<br>
            2.海底捞门店遍及国内外，当下系统无法进行门店统一化运营；<br>
            3.不同时期进行的项目改造，包含多个系统，如点餐、排号等，无法兼容，并在屏幕上实时展示；<br>
            4.现有平台只能满足基本的展示需求，而海底捞希望能具备快捷的交互扩展性，无需进行工程化开发。<br>
          </div>
        </div>
      </div>
   
    <!-- end -->
    <div class="titleBox">
      <div class="anliTitle" style="margin-top:152px">方案策略</div>
      <div class="lineCss"></div>
    </div>
    <div class="grayBox">
      <div
        class="grayBoxText"
      >用数拓平台的开放性，兼容原有点餐、排号、叫号等平台，实现平台统一化运营。同时基于数拓智能应用，从顾客用餐全流程进行互动营销，提升海底捞的服务效率，以及运营效率，实现未来餐厅的智能升级。</div>
      <!-- detailList start -->
      <div class="detailList">
        <div class="detailBox">
          <img :src="detailListIcon1" alt>
          <div class="detailBoxTitle">私有云服务</div>
        </div>
        <div class="detailBox">
          <img :src="detailListIcon2" alt>
          <div class="detailBoxTitle">第三方系统对接</div>
        </div>
        <div class="detailBox">
          <img :src="detailListIcon3" alt>
          <div class="detailBoxTitle">第三方硬件兼容</div>
        </div>
        <div class="detailBox">
          <img :src="detailListIcon4" alt>
          <div class="detailBoxTitle">数据对接</div>
        </div>
        <div class="detailBox">
          <img :src="detailListIcon5" alt>
          <div class="detailBoxTitle">场景aPP</div>
        </div>
      </div>
      <!-- detailList end -->
    </div>
    <!-- 场景解析 start -->
    <div class="titleBox">
      <div class="anliTitle" style="margin-top:152px">场景解析</div>
      <div class="lineCss"></div>
    </div>
    <div class="bgColor paddingBottom86">
      <!-- start -->
      <div class="productParent marginTop109 bgColor">
        <div class="productLeft">
          <img :src="productLeft1">
        </div>
        <div class="productRight">
          <div class="productRightTitle rightTitle1">入口-人脸识别+虚拟迎宾</div>
          <div
            class="productRightText rightText1"
          >如何在客户未进门、甚至是还没决定要进门前，就向其展现贴心的服务。我们选择采用数拓一体机，接入综合传感器后，化身迎宾小能手。无人时，展示数字海报；有人时，可自动识别，屏幕上出现亲切的店员形象，并根据性别、年龄等不同，分别推荐餐品及服务。</div>
        </div>
      </div>
      <!-- end -->
      <!-- start -->
      <div class="productParentTwo">
        <div class="productLeftTwo">
          <div class="productRightTitleTwo">等候区-智能叫号+透明厨房</div>
          <div
            class="productRightText productRightTextTwo"
          >通过H5实现单屏分区展示，除海报展示，通过对接叫号系统、后厨实时监控，实现多内容同屏展示。多个监控信号源，可实现自动切换。</div>
        </div>
        <div class="productRightTwo">
          <img :src="changJingImg2">
        </div>
      </div>
      <!-- end -->
      <!-- start -->

      <div class="productParent bgColor">
        <div class="productLeft">
          <img :src="changJingImg3">
        </div>
        <div class="productRight">
          <div class="productRightTitle rightTitle1">就餐区-智能点餐+透明厨房</div>
          <div
            class="productRightText rightText1"
          >点餐pad装载数拓智屏OS，非点餐状态时，显示品牌宣传海报；开放第三方接口，可跳转点餐系统或播放实时厨房状态。</div>
        </div>
      </div>
      <!-- end -->
      <!-- start -->
      <div class="productParentTwo">
        <div class="productLeftTwo">
          <div class="productRightTitleTwo">自助区-料碗推荐屏</div>
          <div
            class="productRightText productRightTextTwo"
          >自助料碗区装有一块料碗推荐屏，无人时，展示数字海报；有人时，自动识别顾客信息，并推荐相关料碗配方</div>
        </div>
        <div class="productRightTwo">
          <img :src="changJingImg4">
        </div>
      </div>
      <!-- end -->
      <!-- start -->

      <div class="productParent bgColor">
        <div class="productLeft">
          <img :src="changJingImg5">
        </div>
        <div class="productRight">
          <div class="productRightTitle rightTitle1">包间区-个性门牌+服务呼叫</div>
          <div
            class="productRightText rightText1"
          >包间屏幕，可根据用餐需求更换屏幕主题，如生日派对、商务宴请等。屏幕与包间内呼叫系统对接，当顾客点击“呼叫服务”“买单”等功能按键，屏幕切换呼叫页面，跑马灯亮起，提醒服务员及时进行服务。</div>
        </div>
      </div>
      <!-- end -->
    </div>
    <!-- 场景解析 end -->

    <!-- end -->
    <Footer :isMarginTop="true"></Footer>
  </div>
</template>
<script>
import Top from "@/components/top.vue";
import Footer from "@/components/footer.vue";
import bgImg from "@/assets/images/successCaseDetailTop.png";
import productLeft1Top from "@/assets/images/successDetail1.png";
import productLeft1 from "@/assets/images/successDetail1Fu.png";

import detailListIcon1 from "@/assets/images/detailListIcon1.png";
import detailListIcon2 from "@/assets/images/detailListIcon2.png";
import detailListIcon3 from "@/assets/images/detailListIcon3.png";
import detailListIcon4 from "@/assets/images/detailListIcon4.png";
import detailListIcon5 from "@/assets/images/detailListIcon5.png";

import changJingImg1 from "@/assets/images/changJingImg1.png";
import changJingImg2 from "@/assets/images/changJingImg2.png";
import changJingImg3 from "@/assets/images/changJingImg3.png";
import changJingImg4 from "@/assets/images/changJingImg4.png";
import changJingImg5 from "@/assets/images/changJingImg5.png";
import Bread from "@/components/bread.vue";

export default {
  name: "SuccessCaseDetail",
  components: {
    Top,
    Footer,
    Bread
  },
  data() {
    return {
      toBreadChild: ["案例", "海底捞"],
      bgImg: bgImg,
      productLeft1Top: productLeft1Top,
      productLeft1: productLeft1,
      detailListIcon1: detailListIcon1,
      detailListIcon2: detailListIcon2,
      detailListIcon3: detailListIcon3,
      detailListIcon4: detailListIcon4,
      detailListIcon5: detailListIcon4,
      changJingImg1: changJingImg1,
      changJingImg2: changJingImg2,
      changJingImg3: changJingImg3,
      changJingImg4: changJingImg4,
      changJingImg5: changJingImg5
    };
  }
};
</script>
<style scoped>
/* start */
.content {
  position: relative;
}

.bgImgCss {
  width: 100%;
  /* height: 788px; */
}

.imgSrcCss {
  width: 100%;
}

.contentPosition {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  height: 180px;
  text-align: center;
}

.contentTop {
  font-size: 8.7rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  margin-bottom: 77px;
}

.contentBottom {
  text-align: center;
  font-size: 3rem;
  font-family: PingFangSC-Light;
  font-weight: 300;
  color: rgba(255, 255, 255, 1);
  line-height: 45px;
}

/* end  */
/* start */
.anliTitle {
  font-size: 3.6rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
  line-height: 40px;
}

.lineCss {
  width: 80px;
  height: 5px;
  background: rgba(252, 200, 0, 1);
  margin: auto;
  margin-top: 22px;
}

.titleBox {
  text-align: center;
  margin-top: 100px;
}

/* end */
.productParent, .productParentTwo{
  width: 70%;
  margin: auto;
}
.productParent::after {
  content: "";
  display: block;
  clear: both;
}

.productLeft {
  width: 50%;
  float: left;
}

.productLeft img {
  width: 100%;
  /* max-width: 811px; */
}

.productRight {
  width: 43%;
  padding-left: 7%;
  float: left;
}

.productRightTitle {
  font-size: 2rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 31px;
}

.productRightText {
  font-size: 2rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 31px;
  margin-top: 15px;
}

.marginTop109 {
  margin-top: 59px;
}

.grayBoxText {
  width: 53%;
  font-size: 2rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
  margin: auto;
  margin-bottom: 58px;
}

.grayBox {
  background: rgba(240, 240, 240, 1);
  margin-top: 54px;
  padding-bottom: 64px;
  padding-top: 94px;
}

.detailList {
  display: flex;
  width: 70%;
  margin: auto;
}

.detailBox {
  width: 25%;
  text-align: center;
  font-size: 2rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(136, 136, 136, 1);
  line-height: 40px;
}

.bgColor {
  background: rgba(240, 240, 240, 1);
}

.rightTitle1 {
  font-size: 3.2rem;
  font-family: PingFangSC-Light;
  /* font-weight: bold; */
  color: rgba(0, 0, 0, 1);
  line-height: 27px;
  margin-top: 20px;
}

.rightText1 {
  font-size: 2rem;
  font-family: PingFangSC-Light;
  /* font-weight: bold; */
  color: rgba(106, 106, 106, 1);
  line-height: 34px;
  margin-top: 40px;
}

.productParentTwo::after {
  content: "";
  display: block;
  clear: both;
}

.productParentTwo {
  margin-top: 50px;
}

.productLeftTwo {
  width: 40%;
  padding-left: 5%;
  float: left;
}

.productRightTwo {
  width: 50%;
  float: right;
}
.productRightTwo img {

  width: 100%;
}

.productRightTextTwo {
  font-size: 2rem;
  font-family: PingFangSC-Light;
  /* font-weight: bold; */
  color: rgba(106, 106, 106, 1);
  line-height: 35px;
}

.productRightTitleTwo {
  font-size: 3.2rem;
  font-family: PingFangSC-Light;
  /* font-weight: bold; */
  color: rgba(0, 0, 0, 1);
  line-height: 27px;
  margin-top: 30px;
  margin-bottom: 40px;
}

.productParent {
  width: 70%;
  margin: auto;
  margin-top: 50px;
}
.paddingBottom86 {
  padding-bottom: 86px;
  padding-top: 10px;
  margin-top: 80px;
}
/* 左边 left  start */
.leftYellowParent {
  position: relative;
}
.leftYellow {
  position: absolute;
  left: 0;
  top: 80px;
  width: 10%;
  height: 80px;
  background: rgba(252, 200, 0, 1);
}
/* 左边 left  end */
@media screen and (max-width:1200px) {
  .rightTitle1{
    margin-top: 50px;
  }
  .rightText1{
    margin-top: 30px;
    line-height:30px;
  }
  .productRightTitleTwo{
    margin-top: 50px;
  }
  .productRightTextTwo{
     line-height:30px;
  }
  .productRightTitleTwo{
    margin-bottom: 0;
  }
  .productRightTitle{
    line-height: 30px;
  }
  .productRightText{
    line-height: 30px;
  }
  
}
</style>



// WEBPACK FOOTER //
// src/view/SuccessCaseDetail.vue